export default __webpack_public_path__ + "static/media/axia_blue.3d569441.svg";